<template>
  <div>
    <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
      <b-spinner label="Loading..."></b-spinner>
    </div>
    <div class="panel-tag mt-3" v-else-if="!isSpinnerShow && totalEntries == 0">
      {{ $t("table.no_records") }}
    </div>
    <!-- v-if="!isSpinnerShow && totalEntries != 0" -->
    <div v-else class="d-flex">
      <div class="col-lg-4">
        <b-list-group v-if="members.length != 0">
          <b-list-group-item
            button
            v-for="member in members"
            :key="member.memberID"
            @click="selectedMember = member.memberID"
            >{{ member.name }}</b-list-group-item
          >
        </b-list-group>
        <div v-else class="panel-tag">
          .
          {{ $t("table.no_records") }}
        </div>
      </div>
      <div class="col-lg-8">
        <div class="panel-tag" v-if="selectedMember == null">
          .
          {{ $t("table.no_records") }}
        </div>
        <b-jumbotron
          v-for="sku in voucher"
          :key="sku.skuID"
          border-variant="light"
          class="p-5"
        >
          <template #header>{{ sku.name }}</template>
          <hr class="my-2 bg-dark" />

          <b-table
            table-variant="primary"
            small
            striped
            hover
            bordered
            :fields="fields"
            sticky-header
            :items="sku.vouchers"
            responsive="sm"
          >
          </b-table>
          <b-button variant="primary" href="#">More Info</b-button>
        </b-jumbotron>
        <!-- <div class="panel-voucher d-flex justify-content-between" v-for="sku in voucher" :key="sku.skuID">
          <span class="h5 col-sm-4">{{sku.name}}</span>
          <span class="h5 col-sm-4">{{sku.vouchers.length}}</span>
          <span class="h5 col-sm-4">{{total(sku.vouchers)}}</span>
        </div> -->
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
import {
  handleSessionExpired,
  setReturnData,
  getOutletName,
} from "./../../../../assets/js/dashboard/dashboard";
export default {
  name: "voucherList",
  data() {
    return {
      isSpinnerShow: false,
      filterObj: {},
      outlet: [],
      voucherItems: [],
      voucherData: [],
      exportData: [],
      page: 0,
      totalEntries: 0,
      totalPage: 0,
      startPage: 1,
      endPage: 0,
      perPage: 100,
      currentPage: 1,
      limit: 100000,
      members: [],
      membersData: [],
      selectedMember: null,
      voucher: {},
    };
  },
  computed: {
    exportField() {
      var ret = {};
      ret["#"] = "index";
      ret[this.$i18n.t("table.header.name").toUpperCase()] = "name";
      ret[this.$i18n.t("table.header.username").toUpperCase()] = "username";
      ret[this.$i18n.t("table.header.outlet").toUpperCase()] = "outlet";
      ret[this.$i18n.t("table.header.working_hour").toUpperCase()] = "duration";
      ret[this.$i18n.t("table.header.clock_in").toUpperCase()] = "entryDate";
      ret[this.$i18n.t("table.header.clock_out").toUpperCase()] = "exitDate";
      return ret;
    },
    fields() {
      return [
        { key: "index", label: "#", thClass: "thead-themed align-middle" },
        {
          key: "trxnID",
          label: "Transaction ID",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
        {
          key: "price",
          label: "Price",
          thClass: "thead-themed align-middle",
          sortable: true,
        },
      ];
    },
  },
  watch: {
    "$i18n.locale"(val) {
      this.setExportData(this.exportData);
    },
    selectedMember(val) {
      console.log(val);
      this.voucherItems.splice(0, this.voucherItems.length, ...this.voucherData)
      console.log(this.voucherData)
      this.voucher = this.voucherItems.filter((item) => {
        if (item.vouchers != undefined) {
          const saved = item.vouchers;
          item.vouchers = item.vouchers.filter((v) => {
            if (v.memberID == val){console.log("found!");return v}
          });
        }
        if (item.vouchers != undefined && item.vouchers.length > 0) {console.log('triggered');return item}
      });
      console.log(this.voucher)
    },
  },
  methods: {
    total(array) {
      let total = 0;
      array.forEach((element) => {
        total += element.price;
      });
      return total;
    },
    convertTimestampToDateTime(date) {
      return moment(date * 1000).format(this.$msg.CST.DATE_TIME_24);
    },
    getImage(img) {
      return img;
    },
    getDuration(strDuration) {
      var result = "";
      var arrDuration = strDuration.split(":");
      var hr = arrDuration[0];
      var min = arrDuration[1];

      if (hr.indexOf("-") != -1) {
        result = "Present";
      } else {
        hr = parseInt(hr);
        if (hr > 24) {
          var d = Math.floor(hr / 24);
          var rm = hr % 24;
          hr = Math.floor(rm);

          result = d + " Days " + hr + " Hr " + min + " Mins";
        } else {
          result = hr + " Hr " + min + " Mins";
        }
      }
      return result;
    },
    getOutletName(id) {
      return getOutletName(id, this.outlet);
    },
    async setVoucherItems(filterObj) {
      this.isSpinnerShow = true;
      var retData = await this.getVoucherItems();
      var result = setReturnData(retData, this.totalEntries, this.page);
      this.voucherItems = result.result;
      this.voucherData = JSON.parse(JSON.stringify(result.result));
      this.totalPage = result.totalPage;
      console.log(this.voucherData);
      this.startPage = result.startPage;
      this.endPage = result.endPage;
      this.isSpinnerShow = false;
      await this.getExportData();
    },
    async getVoucherItems() {
      let $vm = this;
      let QUERY_STRING = this.$api.VOUCHER + "?limit=" + this.limit;
      if (this.selectView != "") {
        QUERY_STRING = QUERY_STRING + "&status=" + this.selectView;
      }

      const url = QUERY_STRING;

      var result = [];
      var members = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          members = response.data.members;
          let skus = response.data.skus;
          let vouchers = response.data.vouchers;
          result = skus.map((s) => ({
            ...s,
            vouchers: vouchers.filter((v) => v.skuID === s.skuID),
          }));

          result = result.filter((item) => {
            if (item.name != "") return item;
          });
          console.log(result);
          $vm.totalEntries = result.length;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.members = members.filter((item) => {
        if (item.name != "") return item;
      });
      this.membersData = this.members;
      return result;
    },
    async getExportData() {
      let $vm = this;
      let QUERY_STRING = this.$api.REWARDQR + "?delta=" + this.delta;
      const url = QUERY_STRING;
      var result = [];
      await $vm
        .$axios({
          method: "get",
          url: url,
          headers: { token: $vm.$session.get("token") },
        })
        .then(function (response) {
          result = response.data;
          $vm.totalEntries = result.length;
        })
        .catch((err) => {
          var error = err.response.data.error;
          if (error == $vm.$api.INVALID_TOKEN) {
            handleSessionExpired();
          }
        });
      this.exportData = result;
      //this.setExportData(result);
    },
    setExportData(data) {
      var strDate =
        moment(this.filterObj.date.startDate).format(
          this.$msg.CST.DATE_FORMAT
        ) +
        " - " +
        moment(this.filterObj.date.endDate).format(this.$msg.CST.DATE_FORMAT);

      if (this.filterObj.dateType == "all") {
        strDate =
          " (" + this.$i18n.t("salon_report.rewardqr.all_date_types") + ")";
      } else {
        var dateType =
          this.$i18n.messages[this.$i18n.locale].salon_report.rewardqr
            .option_date_filter;
        var strDateType = dateType.filter(
          (obj) => obj.value == this.filterObj.dateType
        )[0].text;

        strDate =
          " (" +
          strDateType +
          ": " +
          moment(this.filterObj.date.startDate).format(
            this.$msg.CST.DATE_FORMAT
          ) +
          " - " +
          moment(this.filterObj.date.endDate).format(
            this.$msg.CST.DATE_FORMAT
          ) +
          ")";
      }

      let header =
        this.$msg.REPORT.HEADER +
        this.$i18n.t("subMenu.my_salon_rewardqr") +
        strDate;
      var exportHeaders = [
        header,
        this.$i18n.t("table.report_generate") +
          moment().format(this.$msg.CST.DATE_TIME_24),
        " ",
      ];

      var exportFileName = header.split(" ").join("_") + this.$msg.REPORT.CSV;

      var exportData = [];
      for (var i = 0; i < data.length; i++) {
        exportData.push({
          index: i + 1,
          name: data[i].name,
          username: data[i].username,
          outlet: this.getOutletName(data[i].outletID),
          entryDate: this.convertTimestampToDateTime(data[i].entryDate),
          exitDate:
            data[i].exitDate == 0
              ? "-"
              : this.convertTimestampToDateTime(data[i].exitDate),
        });
      }

      var exportObj = {
        data: exportData,
        fields: this.exportField,
        headers: exportHeaders,
        fileName: exportFileName,
      };

      this.$emit("setExportData", exportObj);
    },
    async handlePagination(pg) {
      if (pg != null) {
        this.page = pg - 1;
        await this.setVoucherItems();
      }
    },
    filterVoucherByView(data) {
      this.selectView = data;
      this.setVoucherItems();
    },
    searchMemberList(val) {
      console.log(val);
      this.members = this.membersData.filter((item) => {
        if (item.name.includes(val)) {
          return item;
        }
      });
    },
  },
  mounted() {
    let $vm = this;
    $vm.outlet = JSON.parse($vm.$store.state.outlets);
  },
};
</script>
<style scoped>
.panel-voucher {
  padding: 1rem 1rem;
  margin-bottom: 2rem;
  border-left: 3px solid #524f84;
  background: #fbf7f7;
  opacity: 0.8;
  font-weight: 400;
  font-size: 0.875rem;
  border-radius: 0px 8px 8px 0px;
}
</style>